const styles = {
  panelTop: {
    borderRadius: 10,
    display: "flex",
    flexDirection: "column"
  },
  panel: {
    marginTop: '5vh',
    padding: 0,
    width: 500,
    height: "95vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
  },
  panelTitle: {
    backgroundColor: "#f5f5f5",
    borderRadius: "10px 10px 0px 0px",
    color: "black",
    margin: 0,
    paddingLeft: 15,
    padding: 5,
    position: "sticky",
    top: 0
  },
  panelContent: {
    flex: 1,
    overflowY: "scroll"
  },
  stickyFooter: {
    backgroundColor: "white",
    bottom: 0,
    position: "sticky",
    paddingBottom: 15
  }
};

export default styles;
